<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ "bikeshop.shop_setup.card_headers.demos_widget" | translate }}
</span>
    </div>
  </div>

</div>

<div *ngIf="iFrameCreated && !saving" class="container-fluid" >
  <div class="header-container">
    <div class="page-header" style="padding-left: 8px;">
      <span class="fa fa-id-badge"></span>{{ "bikeshop.shop_ride_configuration.widget_preview" | translate }}
    </div>
  </div>
  <div class="content">
    <div class="row" *ngIf="deliveriesEnabled">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.show_deliveries_widget' | translate }}:</div>
      <div class="col-md-1">
        <p-inputSwitch [(ngModel)]="showNonDeliveriesWidget"
                       (onChange)="showDeliveryWidgetChanged()"></p-inputSwitch>
      </div>
      <div class="col-md-9 label">
        <small>{{ 'bikeshop.rentals_configuration.show_deliveries_widget_info' | translate }}</small></div>

    </div>

    <div class="row margin-top-8">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.select_product_categories' | translate }}:
      </div>
      <div class="col-md-2">
        <p-multiSelect [options]="productCategories" [(ngModel)]="selectedProductCategories" [showClear]="false" [showHeader]="false"
          [placeholder]="'bikeshop.rentals_configuration.select_product_categories' | translate"
          (onChange)="showCategoryWidgetChanged($event)"></p-multiSelect>
      </div>
      <div class="col-md-8 label">
        <small>{{ 'bikeshop.rentals_configuration.select_product_categories_description' | translate }}</small>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.select_product_manufacturer_model' | translate }}:
      </div>
      <div class="col-md-2">
        <p-multiSelect [options]="productGroups" [(ngModel)]="selectedProductGroups" [showClear]="false" [showHeader]="false"
          [placeholder]="'bikeshop.rentals_configuration.select_product_manufacturer_model' | translate"
          (onChange)="showCategoryWidgetChanged($event)"></p-multiSelect>
      </div>
      <div class="col-md-8 label">
        <small>{{ 'bikeshop.rentals_configuration.select_product_manufacturer_model_description' | translate }}</small>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 margin-top-16 flex">
        <!-- <div class="copy-link">
      <input type="text" pInputText [(ngModel)]="dangerousURL" [disabled]="true" />
      <span class="fa fa-clipboard" pTooltip="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}"
        (click)="copyLink()"></span>
    </div> -->
        <div>
          <button pButton class="p-button-raised"
                  label="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}"
                  (click)="copyLink()"></button>
        </div>
        <div style="margin-left: 16px">
          <button pButton class="p-button-raised"
                  label="{{'bikeshop.shop_ride_configuration.copy_iframe' | translate}}"
                  (click)="copyiFrame()"></button>
        </div>
      </div>
    </div>
    <div class=" row margin-top-16">
      <div class="col-md-12">
        <div style="border: 1px solid transparent;border-radius: 6px;overflow: hidden;"
             [ngStyle]="{'border-color': config.cardBackground || '#CCC'}">
          <iframe [src]="iFrameLink" width="100%" height="1500px" style="border: 0"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="top-center" styleClass="hubtiger-toast" key="link-copied"></p-toast>
